import Label from "./Label";

export type InputProps = {
  label: string;
  name: string;
  type?: React.HTMLInputTypeAttribute | "textarea";
  required?: boolean;
  onChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  value: string;
  error?: string;
  pattern?: string;
  min?: string | number;
  max?: string | number;
  step?: string | number;
};

const Input = (props: InputProps) => {
  const {
    label,
    name,
    type = "text",
    onChange,
    value,
    error,
    required,
    pattern,
    min,
    max,
    step,
  } = props;

  return (
    <div className="mb-6">
      <Label name={name} required={required}>
        {label}
      </Label>
      {type === "textarea" ? (
        <textarea
          name={name}
          id={name}
          value={value}
          onChange={onChange}
          required={required}
          rows={5}
          className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500"
        />
      ) : (
        <input
          type={type}
          name={name}
          id={name}
          value={value}
          onChange={onChange}
          required={required}
          pattern={pattern}
          min={min}
          max={max}
          step={step}
          className="!bg-gray-50 !border !border-gray-300 !text-gray-900 !text-sm !rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full !p-2.5"
        />
      )}
      {error && <div>{error}</div>}
    </div>
  );
};

export default Input;
